import { useEffect, useState } from 'react';
import { getComplexCreateInitial } from 'src/api';
import { useGetAuthData } from 'src/hooks';
import { ComplexInitialData } from 'src/components/profileComponents/Complexes/types';

export const useComplexCreate = () => {
  const jwt = useGetAuthData().getJWT();
  const [complexInitialData, setComplexInitialData] = useState<ComplexInitialData>();

  useEffect(() => {
    getCreateComplexInitialData();
  }, []);
  const getCreateComplexInitialData = async () => {
    const { data } = await getComplexCreateInitial(jwt);
    setComplexInitialData(data);
  };

  return {
    getCreateComplexInitialData,
    complexInitialData,
  };
};
